// extracted by mini-css-extract-plugin
export default {"input":"CollarSelector_input__uhx3c","rightSection":"CollarSelector_rightSection__CEvoG"};